/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const customFieldFilterSchema = z.object({
  fieldId: z.string(),
  fieldType: z.enum([
    'SELECT',
    'MULTI_SELECT',
    'DATE',
    'DATETIME',
    'TEXT',
    'MULTILINE_TEXT',
    'NUMERIC',
    'CHECKBOX',
    'MULTI_CHECKBOX',
    'USER',
    'MULTI_USER',
    'TEAM',
    'VERSION',
    'COMPONENT',
    'LABELS',
  ]),
  operator: z.enum([
    'EQUALS',
    'NOT_EQUALS',
    'CONTAINS',
    'NOT_CONTAINS',
    'GREATER_THAN',
    'GREATER_THAN_OR_EQUALS',
    'LESS_THAN',
    'LESS_THAN_OR_EQUALS',
    'BETWEEN',
    'NOT_BETWEEN',
    'IN',
    'NOT_IN',
    'IS_EMPTY',
    'IS_NOT_EMPTY',
  ]),
  value: z.optional(z.union([z.array(z.string()), z.string(), z.number(), z.null()])),
});
